<template>
  <div class="container">
    <div class="pageContent">
      <main class="noMenu">
        <template v-for="(item, index) in params.items">
          <blockquote>
            <span style="color: #5573b7; font-weight: 700;">
              {{index+1}}. {{item.title}}
            </span>
          </blockquote>
          <p>{{item.text}}</p>
        </template>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  name: 'faq',
  props: {
    params: {
      type: Object,
      default: {}
    }
  },
  setup(props,ctx) {
    let recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('type', 'application/ld+json');
    let mainEntity = [];
    for(let index in props.params.items) {
      mainEntity.push({
        "@type": "Question",
        "name": props.params.items[index].title,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": props.params.items[index].text
        }
      });
    }


    let shemaOrgData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity":mainEntity
    };
    recaptchaScript.innerHTML = JSON.stringify(shemaOrgData);
    document.body.appendChild(recaptchaScript);
  }
}
</script>


<style lang="scss" scoped>
.pageContent {
  display: flex;
  width: 100%;
  margin-top: 80px;
  justify-content: space-between;
  @include tablet {
    width: 100%;
    margin-top: 50px;
    flex-wrap: wrap-reverse;
  }
  main {
    width: 70%;
    &.noMenu {
      width: 100%;
    }
    @include tablet {
      width: 100%;
    }
  }
  aside {
    width: 26%;
    @include tablet {
      width: 100%;
      margin-bottom: 50px;
    }
  }

}
</style>